import React from 'react'
import { Button } from '@/components/ui/button'
import { Key, Activity, FileText, LucideIcon } from 'lucide-react'

interface Tab {
  id: string
  label: string
  icon: LucideIcon
}

interface PartnerPortalTabsProps {
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
}

const PartnerPortalTabs: React.FC<PartnerPortalTabsProps> = ({ 
  activeTab, 
  onTabChange, 
  className 
}) => {
  const tabs: Tab[] = [
    { id: 'api-keys', label: 'API Keys', icon: Key },
    { id: 'analytics', label: 'Analytics', icon: Activity },
    { id: 'resources', label: 'Resources', icon: FileText },
  ]

  return (
    <div className={`flex gap-2 overflow-x-auto ${className}`}>
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          variant={activeTab === tab.id ? "default" : "outline"}
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <tab.icon size={16} />
          {tab.label}
        </Button>
      ))}
    </div>
  )
}

export default PartnerPortalTabs 